import { BehaviorSubject } from "rxjs";
import { Menu } from "../interface/menu";
import { GlobalConstants } from "../Constants/global.constants";

export const menuItems: Menu[] = [
  // {
  //   main_title: 'General'
  // },


    {
    title: 'Dashboard',
    icon: 'maps',
    active: true,
    type: 'link',
    bookmark: true,
    path: '/device-map',
    level: 1,
  },

    {
    title: 'Analytics',
    icon: 'charts',
    active: true,
    type: 'link',
    bookmark: true,
    path: '/analytics',
    level: 1,
  },


   {
    title: 'Settings',
    icon: 'settings',
    type: 'sub',
    level: 1,
    badge: false,
    badge_value: '3',
    badge_color: 'primary',
    children: [
      {
        path: '/settings/facility', title: 'Facility', type: 'link'
      },
      {
        path: '/settings/devices', title: 'Devices', type: 'link'
      },
      {
        path: '/settings/floors', title: 'Floors', type: 'link'
      },
      {
        path: '/settings/device-placement', title: 'Device Placement', type: 'link'
      },
      {
        path: '/settings/simulation', title: 'Simulation', type: 'link'
      }

    ],

  },

  
  {
    title: 'Device Health & Alerts',
    icon: 'health',
    active: true,
    type: 'link',
    bookmark: true,
    path: '/device-health',
    level: 1,
  },
  {
    title: 'User Management',
    icon: 'user',
    type: 'link',
    bookmark: true,
    // DEV → Control Hub DEV, PRD → Control Hub PRD (via GlobalConstants file replacement)
    path: `${GlobalConstants.CONTROL_HUB_URL}/usermanagement`,
    level: 1,
  }
  
    
  




]

// Array
export const items = new BehaviorSubject<Menu[]>(menuItems);
